import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import products from '../views/products'
import aiot from '../views/aiot'
import llm from '../views/llm'
import solutions from '../views/solutions'
import tech from '../views/tech'
import mall from '../views/mall'
import about from '../views/about'
import detail from '../views/detail'
import projectList from '../views/projectlist'
import video from '../views/video'
import productlist from '../views/productlist'
import activitylist from '../views/activitylist'
import initProject from '../views/initProject'
import login from '../views/login'
import myindex from '../views/myindex'
import myorder from '../views/myorder'
import reg from '../views/reg'
import help from '../views/help'
import helpshow from '../views/helpshow'
import download from '../views/download'
import safe from '../views/safe'

Vue.use(Router)

export default new Router({
  routes: [
    // ==== 主导航页面（v4 改版：首页/产品与服务/解决方案/技术与支持/星选商城/关于我们）====
    { path: '*', redirect: '/index.html' },
    {
      path: '/index.html',
      name: 'home',
      component: index
    },
    {
      path: '/products.html',
      name: 'products',
      component: products
    },
    {
      path: '/service/aiot.html',
      name: 'aiot',
      component: aiot
    },
    {
      path: '/service/llm.html',
      name: 'llm',
      component: llm
    },
    {
      path: '/solutions.html',
      name: 'solutions',
      component: solutions
    },
    {
      path: '/tech.html',
      name: 'tech',
      component: tech
    },
    {
      path: '/mall.html',
      name: 'mall',
      component: mall
    },
    {
      path: '/about.html',
      name: 'about',
      component: about
    },

    // ==== 旧版路由兼容（v3 → v4 重定向）====
    { path: '/product/software.html', redirect: '/products.html' },
    { path: '/product/hardware.html', redirect: '/products.html' },

    // ==== 历史页面（保留兼容，不在主导航展示）====
    {
      path: '/safe.html',
      name: 'safe',
      component: safe
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: detail
    },
    {
      path: '/help.html',
      name: 'help',
      component: help
    },
    {
      path: '/helpshow/:id',
      name: 'helpshow',
      component: helpshow
    },
    {
      path: '/video.html',
      name: 'video',
      component: video
    },
    {
      path: '/activitylist.html',
      name: 'activitylist',
      component: activitylist
    },
    {
      path: '/projectlist.html',
      name: 'projectlist',
      component: projectList
    },
    {
      path: '/productlist.html',
      name: 'productlist',
      component: productlist
    },
    {
      path: '/initproject.html',
      name: 'initproject',
      component: initProject,
      meta: { role: true }
    },
    {
      path: '/login.html',
      name: 'login',
      component: login
    },
    {
      path: '/reg.html',
      name: 'reg',
      component: reg
    },
    {
      path: '/myindex.html',
      name: 'myindex',
      component: myindex,
      meta: { role: true }
    },
    {
      path: '/myorder.html',
      name: 'myorder',
      component: myorder,
      meta: { role: true }
    },
    {
      path: '/download.html',
      name: 'download',
      component: download,
      meta: { keepAlive: false }
    }
  ],
  mode: 'history'
})
